// assets/cart.storage.js
window.CartMethodsStorage = {
    removePriceChangeFromStorage(groupId) {
        let priceChange = JSON.parse(localStorage.getItem('priceChange'));

        if (priceChange && Object.hasOwn(priceChange, groupId)) {
            delete priceChange[groupId];
            if (Object.keys(priceChange).length === 0) {
                this.disableCheckout = false;
                localStorage.removeItem('priceChange');
            } else {
                localStorage.setItem('priceChange', JSON.stringify(priceChange));
            }
        }

        if(this.priceChange && Object.hasOwn(this.priceChange, groupId)){
            delete this.priceChange[groupId];
        }
    },

    removeMinQty(groupId) {
        let minQty = JSON.parse(localStorage.getItem('minQty'));

        if (minQty && Object.hasOwn(minQty, groupId)) {
            delete minQty[groupId];
            if (Object.keys(minQty).length === 0) {
                localStorage.removeItem('minQty');
                this.disableUpdateCart = false;
            } else {
                localStorage.setItem('minQty', JSON.stringify(minQty));
            }
        }

        if (this.minProductQty && Object.hasOwn(this.minProductQty, groupId)) {
            delete this.minProductQty[groupId];

            if (Object.keys(this.minProductQty).length === 0) {
                this.disableUpdateCart = false;
            }
        }
    },

    updateLocalStorage(cart = false) {
        if(cart) {
            this.storageCart = cart;
        }
        //this.storageCart.items = this.cartItems;
        if (this.storageCart) {
            this.storageCart.updated_at = '';
            this.storageCart.updated_at = new Date().getTime();

            // LOG: what fee item original_line_price we are saving to localStorage
            const feeItem = this.storageCart.items?.find(i => i.title?.includes('Associated'));
            console.log('[updateLocalStorage] saving fee item:', {
                original_line_price: feeItem?.original_line_price,
                properties: feeItem?.properties
            });

            localStorage.setItem('cartItems', JSON.stringify(this.storageCart));
        }
    },

    initCartItemsData() {
        let storageCart = null;
        try {
            storageCart = JSON.parse(localStorage.getItem('cartItems'));
            if(JSON.parse(localStorage.getItem('priceChange'))){
                this.disableCheckout = true;
            }
        } catch (e) {
            console.error('localStorage unavailable', e);
        }

        if(this.updateFromLocalStorage && storageCart) {
            this.storageCart = storageCart;

            // LOG: show fee item linePriceProperty from localStorage before init
            const feeItemFromStorage = this.storageCart.items?.find(i => i.title?.includes('Associated'));
            console.log('[INIT] fee item from localStorage:', {
                title: feeItemFromStorage?.title,
                original_line_price: feeItemFromStorage?.original_line_price,
                properties: feeItemFromStorage?.properties
            });

           // this.updateCartInit();
            this.cartItems = this.storageCart.items;
            this.sortCartItems();

            // LOG: after sortCartItems — what is in assocToProduct
            console.log('[INIT] assocToProduct after sortCartItems:', JSON.parse(JSON.stringify(this.assocToProduct)));
            console.log('[INIT] assocPropsEmpty after calculateFee:', JSON.parse(JSON.stringify(this.assocPropsEmpty)));
        } else {
            // Empty or blocked localStorage: build the cart from Shopify
            this.updateCartItemsFromCartJson();
        }

        try {
            let letMinQty = JSON.parse(localStorage.getItem('minQty'));
            if (letMinQty) {
                this.minProductQty = letMinQty;
            }
        } catch (e) {}
        this.disableUpdateCartByMinQty();
    },
};